import { ca } from '@cian/analytics';

export function trackSearchStringClick(isSearchStringCustom: boolean) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'search_string',
    action: 'click_filter',
    label: 'filter',
    page: {
      extra: {
        clickType: 'button',
        is_search_string_custom: isSearchStringCustom,
      },
    },
  });
}
